import { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,  MenuItem, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { IListagemContasPagar } from '../../../shared/services/api/Financeiro/ContasPagar';

export interface ConfirmationDialogRawProps {
    open: boolean;
    dados?: IListagemContasPagar[];
    vselecionado: number;
    onClose: (value?: string) => void;
    ontotal: (value?: number) => void;
    onDados: (dados?: IListagemContasPagar[]) => void;
}
export const DialoDesconto: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { onClose,  open, ...other } = props;
  const [age, setAge] = useState('1');
  const [value, setValue] = useState<string>('0');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');           
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  }; 
  const formatInputValue = (inputValue: string) => {
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.replace(/(\d)(\d{2})$/, '$1,$2');
    inputValue = inputValue.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return inputValue;
  };
  const formatValueNumber = (Value: string) => {
    if (Value === undefined || Value === null) {
      return ''; 
    }  
    Value = Value.replace(/\D/g, '');
    Value = Value.replace(/(\d)(\d{2})$/, '$1.$2');
    Value = Value.replace(/(?=(\d{3})+(\D))\B/g, '');
    return Value;
  };
  const handleSave = () => {
    let descontoPercentual = 0;
    if(age === '1'){
      descontoPercentual = Number(formatValueNumber(value)) * 100 / props.vselecionado;
    }else{
      descontoPercentual = Number(formatValueNumber(value));
    }
    if(descontoPercentual === 0){
      setTms('error');
      setMsg('Valor tem que ser superior a zero');
      setOpenmsg(true);
    }else{
      const dadosComDesconto = props.dados?.map(conta => {
        const desconto = conta.vpagar * (descontoPercentual / 100); 
        const valorpagar = conta.vpagar - desconto;
        return {
          ...conta,
          valorpagar,
          desconto,       };
      });

      const totalComDesconto = dadosComDesconto?.reduce((acumulador, conta) => {
        return acumulador + conta.valorpagar;
      }, 0);

      props.ontotal(totalComDesconto);
      props.onDados(dadosComDesconto);  
      setValue('0');
      setAge('1');
      onClose();
    }
  };

  const Zeradesconto = () => {
    const dadosComDesconto = props.dados?.map(conta => {
      const desconto = 0; 
      const valorpagar = conta.vparcela + conta.acrescimo - conta.vpago;
      return {
        ...conta,
        valorpagar,
        desconto};
    });

    const totalComDesconto = dadosComDesconto?.reduce((acumulador, conta) => {
      return acumulador + conta.valorpagar;
    }, 0);

    props.ontotal(totalComDesconto);
    props.onDados(dadosComDesconto);  
    setValue('0');
    setAge('1');
    onClose();
  };

  const handleCancel = () => {
    setValue('0');
    setAge('1');
    onClose();
  };

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };
 
  return (
    <Dialog 
      open={open}
      {...other}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <DialogTitle>Desconto</DialogTitle>
      <DialogContent dividers>
        <Box 
          gap={1}
          padding={1}
          display="flex"
          alignItems="center"
        >
          <Select
            size='small'
            sx={{ m: 1, minWidth: 125 }}
            value={age}
            onChange={handleChange}
          >
            <MenuItem value={'1'}>Monetário</MenuItem>
            <MenuItem value={'2'}>Percentual</MenuItem>
          </Select>
          <TextField
            size='small'
            label='Desconto'
            value={value || ''}
            onChange={(e) => {
              const inputValue = formatInputValue(e.target.value);
              e.target.value = inputValue;
              setValue(inputValue);
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button  variant='outlined' sx={{marginRight: 10}} color='error' onClick={Zeradesconto}>Zera</Button>
        <Button  variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button  variant='outlined' autoFocus onClick={handleSave}>Confirmar</Button>
      </DialogActions>
    </Dialog>
    
  );
};